export const spacing = {
  0: '0',
  2: '0.125rem',
  4: '0.25rem',
  6: '0.375rem',
  8: '0.5rem',
  10: '0.625rem',
  12: '0.75rem',
  14: '0.875rem',
  16: '1rem',
  18: '1.125rem',
  20: '1.25rem',
  22: '1.375rem',
  24: '1.5rem',
  26: '1.625rem',
  28: '1.75rem',
  30: '1.875rem',
  32: '2rem',
  34: '2.125rem',
  36: '2.25rem',
  38: '2.375rem',
  40: '2.5rem',
  42: '2.625rem',
  44: '2.75rem',
  46: '2.875rem',
  48: '3rem',
  50: '3.125rem',
  52: '3.25rem',
  54: '3.375rem',
  56: '3.5rem',
  58: '3.625rem',
  60: '3.75rem',
  62: '3.875rem',
  64: '4rem',
  66: '4.125rem',
  68: '4.25rem',
  70: '4.375rem',
  72: '4.5rem',
  74: '4.625rem',
  76: '4.75rem',
  78: '4.875rem',
  80: '5rem',
  82: '5.125rem',
  84: '5.25rem',
  86: '5.375rem',
  88: '5.5rem',
  90: '5.625rem',
  92: '5.75rem',
  94: '5.875rem',
  96: '6rem',
  98: '6.125rem',
  100: '6.25rem',
  102: '6.375rem',
  104: '6.5rem',
  106: '6.625rem',
  108: '6.75rem',
  110: '6.875rem',
  112: '7rem',
  114: '7.125rem',
  116: '7.25rem',
  118: '7.375rem',
  120: '7.5rem',
  122: '7.625rem',
  124: '7.75rem',
  126: '7.875rem',
  128: '8rem',
  130: '8.125rem',
  132: '8.25rem',
  134: '8.375rem',
  136: '8.5rem',
  138: '8.625rem',
  140: '8.75rem',
  142: '8.875rem',
  144: '9rem',
  146: '9.125rem',
  148: '9.25rem',
  150: '9.375rem',
  152: '9.5rem',
  154: '9.625rem',
  156: '9.75rem',
  158: '9.875rem',
  160: '10rem',
  162: '10.125rem',
  164: '10.25rem',
  166: '10.375rem',
  168: '10.5rem',
  170: '10.625rem',
  172: '10.75rem',
  174: '10.875rem',
  176: '11rem',
  178: '11.125rem',
  180: '11.25rem',
  182: '11.375rem',
  184: '11.5rem',
  186: '11.625rem',
  188: '11.75rem',
  190: '11.875rem',
  192: '12rem',
  194: '12.125rem',
  196: '12.25rem',
  198: '12.375rem',
  200: '12.5rem',
  202: '12.625rem',
  204: '12.75rem',
  206: '12.875rem',
  208: '13rem',
  210: '13.125rem',
  212: '13.25rem',
  214: '13.375rem',
  216: '13.5rem',
  218: '13.625rem',
  220: '13.75rem',
  222: '13.875rem',
  224: '14rem',
  226: '14.125rem',
  228: '14.25rem',
  230: '14.375rem',
  232: '14.5rem',
  234: '14.625rem',
  236: '14.75rem',
  238: '14.875rem',
  240: '15rem',
  242: '15.125rem',
  244: '15.25rem',
  246: '15.375rem',
  248: '15.5rem',
  250: '15.625rem',
  252: '15.75rem',
  254: '15.875rem',
  256: '16rem',
};
